module.exports = __webpack_public_path__ + "img/micro.b085eeea.png";